module.exports = "<div class=\"card m-0 mb-3 loadingChart text-center full-width\"  l10nTranslate >\n        <br><br><br><br>\n        <span>Please wait{{message}}</span>\n        <br>\n        <span *ngIf=\"contador != ''\">It will take {{contador}} approximately</span>\n        <mat-spinner style=\"align-self: center;\"></mat-spinner>\n        <br>\n    </div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-progress-bar/app-progress-bar.component.html
// module id = ./src/app/components/app-progress-bar/app-progress-bar.component.html
// module chunks = main